/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

/**
 * Getting entire users state into the component
 */
const selectDomain = (state) => state['feature/hotel-set'] || initialState;
/**
 *  Getting selected hotel groups state to dashboard component
 */
export const selectHotelGroups = createSelector([selectDomain], (state) => state.hotelGroups);
/**
 *  Getting hotel group list state to dashboard component
 */
export const selectHotelGroupDropdownList = createSelector(
  [selectDomain],
  (state) => state.hotelGroupsDropdownList
);
/**
 *  Getting hotel group list state to dashboard component
 */
export const selectHotelGroupsList = createSelector(
  [selectDomain],
  (state) => state.hotelGroupsList
);
/**
 *  Getting existed hotel group state to dashboard component
 */
export const selectExistedHotelGroup = createSelector(
  [selectDomain],
  (state) => state.existedHotelGroup
);
/**
 *  Getting selected hotel group name state to dashboard component
 */
export const selectHotelGroupName = createSelector([selectDomain], (state) => state.hotelGroupName);
/**
 *  Getting selected hotel group query state to dashboard component
 */
export const selectHotelGroupQuery = createSelector(
  [selectDomain],
  (state) => state.hotelGroupQuery
);
/**
 *  Getting is organization configuration not found state to the component
 */
export const selectIsConfigurationNotExist = createSelector(
  [selectDomain],
  (state) => state.isConfigurationNotExist
);
/**
 * Getting selected hotel name state to dashboard component
 */
export const selectHotelName = createSelector([selectDomain], (state) => state.hotelName);
/**
 * Getting hotel state to hotel component
 */
export const selectHotels = createSelector([selectDomain], (hotelState) => hotelState.hotels);
/**
 * Getting select schema mapping state to components
 */
export const selectSchemaMapping = createSelector(
  [selectDomain],
  (authState) => authState?.schemaMapping
);
